(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ptw-rack"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ptw-garment-rail')){customElements.define('ptw-garment-rail',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.pieces=Array.from(this.querySelectorAll('[data-piece]'));this.infos=Array.from(this.querySelectorAll('[data-info]'));this.filters=Array.from(this.querySelectorAll('[data-filter]'));this.visiblePieces=this.pieces;this.active=0;this.pieces.forEach(piece=>piece.addEventListener('click',()=>this.select(this.visiblePieces.indexOf(piece))));this.querySelector('[data-prev]').addEventListener('click',()=>this.select(this.active-1));this.querySelector('[data-next]').addEventListener('click',()=>this.select(this.active+1));this.filters.forEach(button=>button.addEventListener('click',()=>{const range=button.dataset.filter;this.visiblePieces=this.pieces.filter(piece=>range==='all'||piece.dataset.range===range);this.filters.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.pieces.forEach(piece=>piece.hidden=!this.visiblePieces.includes(piece));this.select(0)}));this.addEventListener('keydown',event=>{if(event.target.closest('[data-filter]'))return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.select(this.active+(event.key==='ArrowRight'?1:-1));this.visiblePieces[this.active].focus({preventScroll:true})}});const stage=this.querySelector('.ptw-rail__stage');stage.addEventListener('pointerdown',event=>{this.startX=event.clientX;this.startY=event.clientY},{passive:true});stage.addEventListener('pointerup',event=>{if(this.startX===null||this.startX===undefined)return;const dx=event.clientX-this.startX,dy=event.clientY-this.startY;this.startX=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5){this.select(this.active+(dx<0?1:-1));this.swiped=true;setTimeout(()=>this.swiped=false,350)}},{passive:true});stage.addEventListener('click',event=>{if(this.swiped){event.preventDefault();event.stopPropagation()}},true);this.select(0)}select(index){const count=this.visiblePieces.length;if(!count)return;this.active=(index+count)%count;const current=this.visiblePieces[this.active];this.pieces.forEach(piece=>{const local=this.visiblePieces.indexOf(piece);let slot=(local-this.active+count)%count;if(slot>Math.floor(count/2))slot-=count;piece.style.setProperty('--slot',slot);piece.style.setProperty('--side',Math.sign(slot));piece.classList.toggle('is-active',piece===current);piece.setAttribute('aria-pressed',String(piece===current))});this.infos.forEach(info=>info.hidden=info.dataset.info!==current.dataset.piece);this.querySelector('[data-count]').textContent=String(this.active+1).padStart(2,'0');this.querySelector('[data-total]').textContent=String(count).padStart(2,'0')}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ptw-video-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ptw-video-hero')) {
  customElements.define('ptw-video-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const toolbar = this.querySelector('.ptw-video__toolbar');
      const toggle = this.querySelector('[data-video-toggle]');
      const sound = this.querySelector('[data-video-sound]');
      if (!video || !toolbar || !toggle || !sound) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const updatePlayback = () => {
        toggle.textContent = video.paused ? this.dataset.play : this.dataset.pause;
        toggle.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };
      const updateSound = () => {
        sound.textContent = video.muted ? this.dataset.soundOff : this.dataset.soundOn;
        sound.setAttribute('aria-pressed', String(!video.muted));
        sound.setAttribute('aria-label', video.muted ? this.dataset.soundOnLabel : this.dataset.soundOffLabel);
      };
      const play = () => video.play().catch(updatePlayback);
      video.muted = true;
      video.controls = false;
      toolbar.hidden = false;
      video.addEventListener('play', updatePlayback, options);
      video.addEventListener('pause', updatePlayback, options);
      video.addEventListener('volumechange', updateSound, options);
      video.addEventListener('error', () => { video.controls = true; }, options);
      toggle.addEventListener('click', () => {
        if (video.paused) play();
        else video.pause();
      }, options);
      sound.addEventListener('click', () => { video.muted = !video.muted; }, options);
      motion.addEventListener('change', () => {
        if (motion.matches) video.pause();
      }, options);
      if (motion.matches) {
        video.autoplay = false;
        video.pause();
      } else play();
      updatePlayback();
      updateSound();
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
